import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

/**
 * Formly field type for email input
 * Uses HTML5 email input with browser validation
 *
 * Props:
 * - label: string - Field label
 * - placeholder: string - Placeholder text
 * - description: string - Helper text
 * - required: boolean - Whether value is required
 * - pattern: string - Additional regex pattern for validation
 */
@Component({
  selector: 'app-email-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './email-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './email-field.component.css',
})
export class EmailFieldComponent extends FieldType<FieldTypeConfig> {}
